// extracted by mini-css-extract-plugin
export default {"vocabulary":"Vocabulary_vocabulary__5II+s","btnClose":"Vocabulary_btnClose__0WnQh"};